import { Suspense } from 'react'

import Loader from './Loader'

function Loadable<P extends object>(WrappedComponent: React.ComponentType<P>) {
  const WithLoading: React.FC<P> = (props) => {
    return (
      <Suspense fallback={<Loader />}>
        <WrappedComponent {...props} />
      </Suspense>
    )
  }

  return WithLoading
}

export default Loadable
